import { SC } from '../helper/ServerCall';
import { pathSegment } from '../helper/queryString';

export const itineraryService = {
    getBrandsPagination,
    storeItinerary,
    getItineraries,
    editItinerary,
    deleteItinerary,
    updateBrandStatus,
    deleteItineraryDay,
    swapItineraryDays,
    itineraryImageStatus,
    replaceItineraryImage,
    updateItinerariesSortOrders
}

function getBrandsPagination(page, filter, sort, pageSize, status) {
    return SC.getCall('brands', { page, filter, sort, pageSize, status });
}
function storeItinerary(data) {
    return SC.postCall('itineraries', data);
}
function getItineraries(brandId, agencyId, orderId) {
    if (!agencyId) {
        return SC.getCall(`itineraries/${pathSegment(brandId)}`);
    }
    if (orderId) {
        return SC.getCall(`itineraries/${pathSegment(brandId)}/${pathSegment(agencyId)}/${pathSegment(orderId)}`);
    }
    return SC.getCall(`itineraries/${pathSegment(brandId)}/${pathSegment(agencyId)}`);
}
function editItinerary(data, id) {
    return SC.putCall(`itineraries/${pathSegment(id)}`, data);
}
function deleteItinerary(data) {
    return SC.postCall('deleteItinerary', data);
}
function deleteItineraryDay(data) {
    return SC.postCall(`deleteItineraryDay`, data);
}
function updateBrandStatus(brandId, brandData) {
    return SC.putCall(`brandStatusChange/${pathSegment(brandId)}`, brandData);
}

function swapItineraryDays(data) {
    return SC.postCall('swapItineraryDays', data);
}

function itineraryImageStatus(data) {
    return SC.postCall('itineraryImageStatus', data);
}

function replaceItineraryImage(data) {
    return SC.postCall('replaceItineraryImage', data);
}
function updateItinerariesSortOrders(data) {
    return SC.postCall('updateItinerariesSortOrders', data);
}
